module.exports = __webpack_public_path__ + "img/tire-1.55ba096a.png";